import classNames from 'classnames'
import styles from './Typography.module.scss'
export const Typography = ({
  onClick,
  variant,
  className,
  color,
  children,
  id
}) => {
  const Tags = {
    h1: 'h1',
    h2medium: 'h2',
    h3semi: 'h3',
    h4semi: 'h4',
    h4regular: 'h4',
    h5regular: 'h5',
    h6regular: 'h6',
    h6medium :'h6',
    p: 'p',
    span: 'span',
  }

  const classNamedGenerated = classNames(
    styles[variant],
    styles[color],
    className
  )

  const TagName = Tags[variant in Tags ? variant : 'p']

  return (
    <TagName onClick={onClick} id={id} className={classNamedGenerated}>
      {children}
    </TagName>
  )
}
